import { Directive, Input, HostBinding } from '@angular/core';

@Directive({
    selector: '[appLoadingBlur]'
})
export class LoadingBlurDirective {
  @Input('appLoadingBlur') isLoading = false;

  @HostBinding('class')
  get applyClasses(): string {
      return this.isLoading ? 'blur-sm pointer-events-none' : '';
  }
}
